
export default {

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.unloadHandler)
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.unloadHandler)
  },
  methods: {
    unloadHandler(event) {
      if ( this.checkChages()) {
        event.preventDefault()
        event.returnValue = ' '
        return   ' '
      }
    },
  }
}
